import React from 'react';
import ShowData from '../components/ShowData';
import BottomNav from '../components/BottomNav';

export default function Home() {
  return (
    <>
      <BottomNav />
      <ShowData />
    </>
  );
}
